import React from 'react';
import {
  openPopupWindow,
} from '../../../../../../emitters/popup';
import WrapperWithLoading from '../../../../../dumb/WrapperWithLoading/B';
import Popup from '../../../../../dumb/Popup/B';
import ButtonM from '../../../../../dumb/Button/Decline';
import ButtonN from '../../../../../dumb/Button/Accept';


module.exports = (data, callback) => {
  data = data || {};

  openPopupWindow((setPopupState, popup) => {
    const {
      close,
    } = popup;
    return (stateOfPopup) => {
      return (
        <Popup
          caption="Are you sure you want to disable two-factor authentication?"
        >
          <WrapperWithLoading
            loading={stateOfPopup.loading}
          >
            <div className="cfx mt40 mh-28 (lt|ph28|pb20)>1">
              <div>
                <ButtonN
                  onClick={() => {
                    close();
                    callback && callback();
                  }}
                >Disable</ButtonN>
              </div>
              <div>
                <ButtonM
                  onClick={close}
                >Cancel</ButtonM>
              </div>
            </div>
          </WrapperWithLoading>
        </Popup>
      );
    };
  });
};
